import { stringArrayToObject } from '../../utils/array';

/* ------------- Auth actions ------------- */
export const actions = stringArrayToObject(['INITIALIZE'], '@@Application');

export const actionCreators = {
  init() {
    return {
      type: actions.INITIALIZE,
      payload: {},
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Application/actions.js